import React, { useState } from "react";
import styled from "styled-components";
import useDragAndDrop from "../../Model/Share/Normal/useDragAndDrop";

export default function CenterLogoImage(props) {
  const { profile, defaultProfile, onFileSelect, enableDragDrop = false } = props;

  const [isErrorProfile, setIsErrorProfile] = useState(false);

  // Drag & Drop hook 사용 //
  const { isDragOver, dragHandlers } = useDragAndDrop({
    onFileSelect,
    enableDragDrop
  });

  // 사진 불러오기 에러시 //
  function onError() {
    setIsErrorProfile(true);
  }

  // 화면에 표시할 사진 결정 //
  function decideUserProfile() {
    if (isErrorProfile || profile === undefined || profile === '') return defaultProfile;
    else return profile;
  }

  return (
    <ProfileWrapper
      $isDragOver={isDragOver}
      $enableDragDrop={enableDragDrop}
      {...dragHandlers}>
      <Profile src={decideUserProfile()} onError={onError}/>
    </ProfileWrapper>
  );
}

const ProfileWrapper = styled.div`
  width: 100%;
  height: 100%;

  border-radius: 10px;

  outline: 2px solid ${props => props.$isDragOver ? props.theme.primary : 'transparent'};
  outline-offset: -2px;

  overflow: hidden;

  transition: border-color 0.2s ease-in-out;
`;

const Profile = styled.img`
  width: 100%;
  height: 100%;

  object-fit: contain;
`;